import { InsMonitorTimeModel } from '@/types/home';
import styles from './index.module.less';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import { changeDate } from '@/shared/utils';
import { useRouter } from 'next/router';
import { useState } from 'react';
import ActiveAccountModal from '@/components/ActiveAccountModal/index';
import classNames from 'classnames';
import { useUserProvider } from '@/context/UserProvider';
export const ReportEmpty = ({
  data,
  title,
  desc,
  isStories,
}: {
  data?: InsMonitorTimeModel;
  title?: string;
  desc?: string;
  isStories?: boolean;
}) => {
  const { t } = useTranslation();
  const router = useRouter();

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const getDescStr = () => {
    if (isStories) {
      return (
        <>
          <div>{title + ' ' + changeDate(data?.show_time, 'YYYY-MM-DD')}</div>
          <div>{desc}</div>
        </>
      );
    } else if (data === undefined) {
      return t('emptyData');
    } else if (data?.private_mark) {
      let title = '';
      let titleDesc = '';
      switch (data?.private_mark) {
        case 1:
          title = t("Due to the Instagram account you're tracking being set to private, we can't deliver the report.");
          titleDesc = t(
            "DolphinRadar will continue monitoring, and once it's public again, we'll send you the report for this period."
          );
          break;
        case 2:
          title = t(
            'The Instagram account you’re tracking is currently inaccessible, so we can’t send reports right now.'
          );
          titleDesc = t(
            'DolphinRadar will keep monitoring the account and send the reports once it’s accessible again.'
          );
          break;
      }
      return (
        <>
          <Image src={'/images/report/lock-icon.webp'} alt={'lock'} loading="lazy" width={223.21} height={186.6} />
          <div className={styles.desc}>
            <h4>{title}</h4>
            <div>{desc || titleDesc}</div>
            <div>
              {t('empytReport footer')}
              <a href="mailto:info.dolphinradar@gmail.com">info.dolphinradar@gmail.com</a>
            </div>
          </div>
        </>
      );
    } else {
      return (
        <div onClick={() => handleOpenAlay()}>
          <div>
            {t('Your Activity Report will be delivered by timeStr.').replace(
              'timeStr',
              changeDate(data?.show_time, 'YYYY-MM-DD')
            )}
          </div>
          <div style={{ color: 'var(--app-primary-color)' }}>
            {t('By Past Report, Know More About CountName').replace('CountName', `(${router.query.name})`)}
          </div>
        </div>
      );
    }
  };

  // 打开报告
  const handleOpenAlay = () => {
    if (!router.query.isDemo) {
      setIsModalOpen(true);
    }
  };

  return (
    <div className={styles.content}>
      {!data?.private_mark && (
        <Image src={'/images/report/empty-icon.webp'} alt={'empty'} loading="lazy" width={200} height={167} />
      )}
      <img src={`/images/report/data-loading-${router?.locale}.gif`} alt="" />
      <div className={styles.desc}>{getDescStr()}</div>
      {!router.query.isDemo ? (
        <ActiveAccountModal
          routerInfo={router.query}
          isModalOpen={isModalOpen}
          closeFn={() => {
            setIsModalOpen(false);
          }}
        />
      ) : (
        ''
      )}
    </div>
  );
};

export const ReportSubEmpty = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.content} style={{ height: '300px' }}>
      <div className={styles.desc}>
        <div>{t('No activity found during this period')}</div>
        <div>{t('This may happen if the tracked user has not posted or engaged on Instagram recently')}</div>
      </div>
    </div>
  );
};

export const ReportSingleEmpty = () => {
  const router = useRouter();
  const { t } = useTranslation();
  const { isLogin, onOpenLoginModal, onChangedLoginView } = useUserProvider();

  const onSettingsClick = () => {
    if (!isLogin) {
      onOpenLoginModal(true);
      onChangedLoginView(false);
      return;
    }
    router.push('/settings');
  };

  return (
    <div className={classNames([styles.reportContent, styles.content])}>
      <div className={styles.reportEmptyContainer}>
        <img className={styles.reportEmptyIcon} src={'/images/report/empty-icon.webp'} alt={'empty'} loading="lazy" />
        <p className={styles.reportDescContainer}>
          <div>
            <img
              className={styles.reportEmptyLoadingIcon}
              src={`/images/report/data-loading-${router?.locale}.gif`}
              alt=""
            />
            <img src="/images/report/loading-icon.svg" alt="" />
          </div>
          <span>{t('Updates will appear here once your tracking report is ready.')}</span>
          <span>{t('Make sure your notification email is set up in')}</span>
          {` `}
          <span onClick={onSettingsClick} className={styles.settings}>
            {t('Settings')}
          </span>
          .
        </p>
      </div>
    </div>
  );
};

export const StoriesNoStartEmpty = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.content}>
      <Image src={'/images/report/empty-icon.webp'} alt={'empty'} loading="lazy" width={200} height={167} />
      <div className={styles.desc}>{t('Instagram Stories Insights are on the way')}</div>
    </div>
  );
};
